var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRatingsBadgeIcon = function SvgRatingsBadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ratings-badge-icon_svg__a)",
    filter: "url(#ratings-badge-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30.92 9.385 19.107 2.708a2.26 2.26 0 0 0-2.214 0L5.08 9.385a2.25 2.25 0 0 0-1.142 1.959v13.312a2.25 2.25 0 0 0 1.142 1.959l11.813 6.677a2.26 2.26 0 0 0 2.214 0l11.813-6.677a2.25 2.25 0 0 0 1.142-1.959V11.344a2.25 2.25 0 0 0-1.142-1.959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ratings-badge-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ratings-badge-icon_svg__b",
    width: 40,
    height: 40,
    x: -2,
    y: -1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1677_2397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1677_2397",
    result: "shape"
  })))));
};
export default SvgRatingsBadgeIcon;